import attendance from './attendance'
import report from './report'

export default [
  ...attendance,
  ...report,
]
